import { render } from "./mainCategory-form.vue?vue&type=template&id=e2482220"
import script from "./mainCategory-form.vue?vue&type=script&lang=js"
export * from "./mainCategory-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__